module.exports = __webpack_public_path__ + "static/img/IT.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/IT.png
// module id = DDen
// module chunks = 1